export default "__VITE_ASSET__CI0pPTEU__"